const monthType = {
  headerName: 'Month',
  field: 'month',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 70,
  // suppressSizeToFit: true,
};

const contactType = {
  headerName: 'Contact Type',
  field: 'type',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 155,
  // suppressSizeToFit: true,
};

const subType = {
  headerName: 'Sub Type',
  field: 'subtype',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 100,
  // suppressSizeToFit: true,
};

const programDef = {
  headerName: 'Program',
  field: 'programname',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 100,
  // suppressSizeToFit: true,
};

const griefRiskFrom = {
  headerName: 'Grief Risk from',
  field: 'griefriskfrom',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 100,
  // suppressSizeToFit: true,
};

const griefRiskTo = {
  headerName: 'Grief Risk To',
  field: 'griefriskto',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 100,
  // suppressSizeToFit: true,
};

const roleDef = {
  headerName: 'Role',
  field: 'rolename',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 120,
  // suppressSizeToFit: true,
};
const descriptionDef = {
  headerName: 'Description',
  field: 'description',
  cellClass: 'no-border',
  suppressMenu: true,
  width: 150,
  // suppressSizeToFit: true,
};

export const smallWidgetPatientColumnDefs = [
  monthType,
  programDef,
  contactType,
];

export const expandedWidgetPatientColumnDefs = [
  ...smallWidgetPatientColumnDefs,
  subType,
  griefRiskFrom,
  griefRiskTo,
  roleDef,
  descriptionDef,
];
